export interface ParsedEvent {
  startTime: string;
  endTime: string;
  category: string;
  detail: string | null;
  location: string | null;
}

export interface ParsedPractice {
  detectedDate: string | null;
  sourceLabel: string | null;
  events: ParsedEvent[];
}

export interface ParseResponse {
  practices: ParsedPractice[];
}

export const PRACTICE_PLAN_MAX_FILE_SIZE_MB = 20;
export const PRACTICE_PLAN_MAX_ROWS = 200;
export const PRACTICE_PLAN_ALLOWED_MIME = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
];

export function eventNameSuffix(e: ParsedEvent): string {
  const detail = (e.detail ?? '').trim();
  return detail || e.category;
}
